<template>
  <div class="tinymce-container editor-container" :class="{ fullscreen : fullscreen }">
    <textarea class="tinymce-textarea" :id="tinymceId" v-model="value"></textarea>
    <div class="editor-custom-btn-container">
      <editor-image color="#1890ff" class="editor-upload-btn" @successCBK="imageSuccessCBK"></editor-image>
    </div>
  </div>
</template>

<script>
  import EditorImage from './components/EditorImage'
  import plugins from './plugins'
  import toolbar from './toolbar'
  
  export default {
    name: 'tinymce',
    components: {
      EditorImage
    },
    props: {
      id: {
        type: String
      },
      value: {
        type: String,
        required: true,
      },
      text: {
        type: String,
        default: ''
      },
      toolbar: {
        type: Array,
        required: false,
        default: () => []
      },
      menubar: {
        default: 'file edit table'
      },
      height: {
        type: Number,
        required: false,
        default: 360
      }
    },
    data() {
      return {
        hasChange: false,
        hasInit: false,
        tinymceId: this.id || 'vue-tinymce-' + +new Date(),
        fullscreen: false,
        editor: null,
        focus: false
      }
    },
    watch: {
      value(val) {
        // if (!this.hasChange && this.hasInit) {
        if (!this.focus || !this.hasChange) {
          this.$nextTick(() => window.tinymce.get(this.tinymceId).setContent(val))
        }
      }
    },
    mounted() {
      this.initTinymce()
    },
    activated() {
      this.initTinymce()
    },
    deactivated() {
      this.destroyTinymce()
    },
    computed: {
      uploadUrl() {
        return SZH.assets.api + '/File?Data=NewsPicture&UserId=' + localStorage.getItem('ms_userid')
      }
    },
    methods: {
      initTinymce() {
        const self = this
        window.tinymce.init({
          selector: `#${this.tinymceId}`,
          height: this.height,
          theme: 'modern',
          menubar: this.menubar,
          toolbar: this.toolbar.length > 0 ? this.toolbar : toolbar,
          plugins: plugins,
          
          // CONFIG
          
          forced_root_block: 'p',
          force_p_newlines: true,
          importcss_append: true,
          body_class: 'panel-body ',
          object_resizing: true,
          
          // CONFIG: ContentStyle
          content_style: `
            *                         { padding:0; margin:0; }
            html, body                { height:auto; }
            img                       { max-width:100%; display:block;height:auto; }
            a                         { text-decoration: none; }
            iframe                    { width: 100%; }
            p                         { line-height:1.6; margin: 0px; }
            table                     { word-wrap:break-word; word-break:break-all; max-width:100%; border:none; border-color:#999; }
            .mce-object-iframe        { width:100%; box-sizing:border-box; margin:0; padding:0; }
            ul,ol                     { list-style-position:inside; }
          `,
          
          // CONFIG: StyleSelect
          style_formats: [
            {
              title: '首行缩进',
              block: 'p',
              styles: {
                'text-indent': '2em'
              }
            },
            {
              title: '行高',
              items: [
                {
                  title: '1',
                  styles: {
                    'line-height': '1'
                  },
                  inline: 'span'
                },
                {
                  title: '1.5',
                  styles: {
                    'line-height': '1.5'
                  },
                  inline: 'span'
                },
                {
                  title: '2',
                  styles: {
                    'line-height': '2'
                  },
                  inline: 'span'
                },
                {
                  title: '2.5',
                  styles: {
                    'line-height': '2.5'
                  },
                  inline: 'span'
                },
                {
                  title: '3',
                  styles: {
                    'line-height': '3'
                  },
                  inline: 'span'
                }
              ]
            }
          ],
          
          // CONFIG: Font
          fontsize_formats: '10px 11px 12px 14px 16px 18px 20px 24px',
          
          // FontSelect
          font_formats: `
            微软雅黑=微软雅黑;
            宋体=宋体;
            黑体=黑体;
            仿宋=仿宋;
            楷体=楷体;
            隶书=隶书;
            幼圆=幼圆;
            Times New Roman=times new roman,times;
            Tahoma=tahoma,arial,helvetica,sans-serif;
            Terminal=terminal,monaco;
            Trebuchet MS=trebuchet ms,geneva;
            Comic Sans MS=comic sans ms,sans-serif;
            Georgia=georgia,palatino;`,
          // Andale Mono=andale mono,times;
          // Arial=arial, helvetica,
          // sans-serif;
          // Arial Black=arial black, avant garde;
          // Book Antiqua=book antiqua,palatino;
          // Courier New=courier new,courier;
          // Helvetica=helvetica;
          // Impact=impact,chicago;
          // Symbol=symbol;
          // Verdana=verdana,geneva;
          // Webdings=webdings;
          // Wingdings=wingdings,zapf dingbats`,
          
          end_container_on_empty_block: true,
          
          // CONFIG: Paste
          paste_retain_style_properties: 'all',
          paste_word_valid_elements: '*[*]',        // word需要它
          paste_convert_word_fake_lists: false,     // 插入word文档需要该属性
          paste_webkit_styles: 'all',               // 粘贴word样式
          paste_merge_formats: true,
          nonbreaking_force_tab: false,
          paste_auto_cleanup_on_paste: false,
          
          
          //
          code_dialog_height: 450,
          code_dialog_width: 1000,
          advlist_bullet_styles: 'square',
          advlist_number_styles: 'default',
          default_link_target: '_blank',
          link_title: false,
          init_instance_callback: editor => {
            if (self.value) {
              editor.setContent(self.value)
            }
            self.hasInit = true
            editor.on('NodeChange Change KeyUp SetContent', () => {
              self.hasChange = true;
              self.$emit('input', editor.getContent());
              let text = editor.getContent({
                format: 'text'
              })
              self.$emit('update:text', text.substring(0, 500));
            })
            editor.on('focus', () => {
              this.focus = true;
            })
            editor.on('blur', () => {
              this.focus = false;
              this.hasChange = false;
            })
          },
          setup(editor) {
            editor.on('FullscreenStateChanged', (e) => {
              self.fullscreen = e.state
            })
          }
        });
        self.editor = window.tinymce.get(self.tinymceId);
      },
      destroyTinymce() {
        if (this.editor) {
          //this.editor.destroy()
        }
      },
      setContent(value) {
        this.editor.setContent(value)
      },
      getContent() {
        this.editor.getContent()
      },
      imageSuccessCBK(arr) {
        const self = this
        arr.forEach(v => {
          self.editor.insertContent(`<img class="wscnph" src="${v.url}" >`)
        })
      }
    },
    destroyed() {
      this.destroyTinymce()
    }
  }

</script>

<style scoped>
  .tinymce-container {
    position: relative;
  }
  
  .tinymce-container >>> .mce-fullscreen {
    z-index: 10000;
  }
  
  .tinymce-textarea {
    visibility: hidden;
    z-index: -1;
  }
  
  .editor-custom-btn-container {
    position: absolute;
    right: 4px;
    top: 4px;
    /*z-index: 2005;*/
  }
  
  .fullscreen .editor-custom-btn-container {
    z-index: 10000;
    position: fixed;
  }
  
  .editor-upload-btn {
    display: inline-block;
  }
  
  .el-form-item__content .editor-upload-btn,
  .el-form-item__content .editor-custom-btn-container {
    line-height: 26px;
  }

</style>



// WEBPACK FOOTER //
// src/tycomponents/Editor/index.vue